import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { BackendResponse, DataManagementService, DeviceService, HttpService, ScreenSize, ToastrService, TranslateService } from 'vas-mobile-api';

import { Card, CardDestination, Holiday, HolidayCard } from '../models/card';
import { Column, Operator, Option } from '../models/chips-and-fields';
import { Delivery } from '../models/delivery';
import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject();

  public cards: Card[] = [
    {
      id: 'total',
      title: 'LABEL_CURRENT_DELIVERIES',
      icon: 'mdi-truck',
      destination: {
        path: 'statusList'
      }
      // },
      // {
      //   id: 'reports',
      //   title: 'VASTREE_DMTN4',
      //   icon: 'mdi-file',
      //   destination: {
      //     path: 'reportsList'
      //   }
    }
  ];

  public holidayCard: HolidayCard = {
    id: 'holidays',
    title: 'LABEL_UPCOMING_HOLIDAYS',
    content: []
  };

  public columnKeys: string[];
  public showTable: boolean;
  public deliveries: Delivery[];
  public columns: Column[];
  public showLoading: boolean;
  public locale: string;

  constructor(
    private deviceService: DeviceService,
    private httpService: HttpService,
    private router: Router,
    private des: DataExchangeService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private dataManagementVasService: DataManagementService
  ) { }

  ngOnInit() {
    this.locale = this.translateService.getLanguage();
    this.dataManagementVasService.getUserType().then((type) => {
      let pathConfig = '';
      if (type === 'SUPP') {
        pathConfig = 'assets/config/dashboardConfig_inbound.json';
      } else {
        pathConfig = 'assets/config/dashboardConfig.json';
      }
      this.httpService.getLocalResource(pathConfig).subscribe((config: { columns: Column[] }) => {
        this.columns = config.columns;
        this.columnKeys = this.columns.map((v) => v.key);

        this.getHolidays();

        this.deviceService.size.pipe(takeUntil(this.ngUnsubscribe)).subscribe((size) => {
          this.showTable = size > ScreenSize.sm;
          if (this.showTable && !this.deliveries) {
            this.getLatestDeliveries();
          }
        });
      });
    });

    this.getCardsData();

    this.des.refresh$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.getLatestDeliveries();
    });

    this.des.changeTitelBarName('LBLPANEL_DASHBOARD');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public navigate(destination: CardDestination) {
    this.router.navigate([destination.path], { queryParams: destination.queryParams });
  }

  public navigateDelivery(id: string) {
    this.router.navigate(['deliveryDetail', id]);
  }

  public navigateNewDelivery() {
    this.dataManagementVasService.getUserType().then((type) => {
      if (type === 'SUPP') {
        this.router.navigate(['newInboundDelivery']);
      } else {
        this.router.navigate(['newDelivery']);
      }

    });

  }

  private getCardsData() {
    const requestAll = this.httpService.get<BackendResponse<[{ COUNT: number }]>>({ pathId: 'getFilteredDeliveryAmount' })
      .pipe(map((r) => ({ total: r.data[0].COUNT })));
    requestAll.subscribe((data) => {
      this.cards.forEach((card) => {
        const value = data[card.id];
        if (value) {
          card.content = value;
        }
      });
    }, (e) => {
      this.toastrService.error(e);
    });

  }

  private getLatestDeliveries() {
    this.showLoading = true;
    this.httpService.post<BackendResponse<Delivery[]>>(
      {
        pathId: 'listFilteredDeliveriesWithLimit',
        payload: [{ key: 'LIEFERSCHEINSTATUS', value: 'L', operator: Operator.NOT },
        { key: 'LIEFERSCHEINSTATUS', value: 'S', operator: Operator.NOT },
        // { key: 'VORGANGS_CODE', value: 'ABX', operator: Operator. },
        { key: 'VORGANGS_CODE', value: 'AGX', operator: Operator.NOT }
        ],
        urlParams: {
          limit: 5,
          orderBy: ['LIEFER_NR DESC'],
          fields: this.columnKeys,
        }
      }
    ).subscribe((result) => {
      this.showLoading = false;
      this.deliveries = result.data;
    }, () => {
      this.showLoading = false;
    });
  }

  public getOptionValue(options: Option[], key: string) {
    if (key) {
      const option = options.find((o) => o.key === key);
      return option ? option.value : key;
    }
    return '';
  }

  private getHolidays() {
    this.httpService.get<BackendResponse<any>>({ pathId: 'getSpecialDaysAtIssue' }).subscribe((response) => {
      response.data.forEach((d) => {
        const holiday: Holiday = {
          eventName: d.BESCHREIBUNG,
          eventTime: d.FEIERTAG_DATE
        };
        this.holidayCard.content.push(holiday);
      });
    });
  }

}
